import { endOfToday, startOfToday, subDays } from 'date-fns';

import {
  TO,
  SORT,
  FROM,
  MODES,
  BRANDS,
  SEARCH,
  PAYMENT_TYPES,
  PAYMENT_PROGRESS_STATUS,
  PAYMENT_PROVIDERS,
  DISPLAY_UNCOMPLETED_PAYMENT,
} from 'constants/FilterConstants';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';
import * as types from 'modules/payments/actionTypes';
import { getPersistedFilters } from 'services/StateLoader';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {'text' | 'type' | 'paymentProgressStatus' | 'paymentProviders' | 'brands' | 'modes' | 'displayUncompleted' } FilterPaymentField */

/** @typedef {Record<FilterPaymentField, string | number | Array<string> | Array<number>>} PaymentsFiltersReducer */

const DEFAULT_SORT = 'modifiedOn,asc';

const persistedFilters = getPersistedFilters()?.filters?.payments ?? {};

const emptyState = {
  [PAYMENT_TYPES]: [],
  [MODES]: [],
  [BRANDS]: [],
  [SEARCH]: null,
  [SORT]: DEFAULT_SORT,
  [PAYMENT_PROVIDERS]: [],
  [PAYMENT_PROGRESS_STATUS]: [],
  [DISPLAY_UNCOMPLETED_PAYMENT]: false, // Fake filter
  [TO]: endOfToday().toISOString(),
  [FROM]: subDays(startOfToday(), 6).toISOString(),
};

/** @type {FilterAdapter<PaymentsFiltersReducer>} */
const filterAdapter = filterSliceAdapter(emptyState, persistedFilters);

export default createReducer(filterAdapter.getInitialState(), {
  [types.SET_PAYMENT_DASHBOARD_FILTER]: filterAdapter.setFilter,
  [types.SET_PAYMENT_DASHBOARD_FILTERS]: filterAdapter.setFilters,
  [types.CLEAR_PAYMENT_DASHBOARD_FILTER]: filterAdapter.resetFilters,
  [types.REMOVE_PAYMENT_DASHBOARD_FILTER]: filterAdapter.removeFilter,
});
